export class GameTimer extends SpinePlugin.SpineGameObject {
  constructor(scene, x, y) {
    super(scene, scene.spine, x, y, 'timer', '', true);
    scene.add.existing(this);

    this._state = 'idle';
    this.timeAnimationData = this.findAnimation('animation');
    this.timeAnimation = false;
  }

  enter() {
    this.timeScale = 1;
    this.timeAnimation = false;
    this.play('in');
    this.timerFX = this.scene.game.soundController.playSFX('general', 'general_timer', {
      loop: true,
    });
  }

  updateTimerFX() {
    if (!this.timerFX.isPlaying) return;
    this.timerFX.stop();
    this.endTimerFX = this.scene.game.soundController.playSFX('general', 'general_timer_end', {
      loop: true,
    });
  }

  exit() {
    this.timeScale = 1;
    this.timeAnimation = false;
    this.play('out');
    if (this.endTimerFX) {
      this.endTimerFX.stop();
      this.endTimerFX = null;
    }
  }

  setTimePercent(percent) {
    this.timeScale = 0;
    const time = this.timeAnimationData.duration * (1 - percent);
    if (!this.timeAnimation) this.timeAnimation = this.state.setAnimation(0, 'animation', false);
    this.timeAnimation.trackTime = time;

    if (percent < 0.2) {
      this.updateTimerFX();
    }
  }
}
